export default __webpack_public_path__ + "static/media/mainLogo.d7726927.svg";